export const ROUTES = {
  NOTIFICATION_BASE: "/notifications",
  NOTIFICATION_DETAILS: "/notifications/details",
  NOTIFICATION_LIST: "/notifications/list",
};
